import { createSlice } from "@reduxjs/toolkit";
import { ACTIVE_VIEW_COUNTRY } from "../../utils/Constants.tsx";

const initialState = {
  isLoading: false,
  statesData: [],
  statesDataWithId: [],
  districtsData: [],
  districtsDataWithId: [],
  error: null,
  activeView: ACTIVE_VIEW_COUNTRY,
  products: [],
  seasons: [],
  levelOne: [],
  levelTwo: [],
  levelThree: [],
};

export const filterSectionSlice = createSlice({
  name: "filterSectionSlice",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    storeStatesData(state, action) {
      state.isLoading = false;
      state.statesDataWithId = action.payload; 
      state.statesData = action.payload?.map(element => element.vstate);
    },
    storeDistrictsData(state, action) {
      state.isLoading = false;
      state.districtsDataWithId = action.payload;
      state.districtsData = action.payload?.map(element => element.vdistrict);
    },
    updateActiveView(state, action) {
      state.activeView = action.payload;
    },
    storeProducts(state, action){
      state.products = action.payload;
    },
    storeSeasons(state, action){
      state.seasons = action.payload;
    },
    storeLevelOne(state, action){
      state.levelOne = action.payload;
    },
    storeLevelTwo(state, action){
      state.levelTwo = action.payload?.level2_names || [];
    },
    storeLevelThree(state, action){
      state.levelThree = action.payload;
    },
    clearDistrictArray(state, action) {
      state.districtsData = [];
      state.districtsDataWithId = [];
    },
    clearLevelThreeArray(state, action) {
      state.levelThree = [];
    }
  },
});

export const {
  startLoading,
  stopLoading,
  hasError,
  storeStatesData,
  storeProducts,
  storeSeasons,
  storeLevelOne,
  storeLevelTwo, 
  storeLevelThree,
  storeDistrictsData,
  updateActiveView,
  clearDistrictArray,
  clearLevelThreeArray
} = filterSectionSlice.actions;

export default filterSectionSlice.reducer;